<div class="chips-cell" (click)="onClickShowMore()" [ngClass]="{ open: showMore }">
  <div class="example-chip-list">
    <mat-chip-grid #chipList aria-label="Members">
      <div class="display-block" [ngClass]="{ open: showMore }">
        @for (memberId of group()?.membersIds; let i = $index; track memberId) {
          @if (showMore || i < 1) {
            <mat-chip-row class="example-chip-list__chip" (removed)="remove(memberId)">
              {{ getMemberName(memberId) }}
              @if (showMore) {
                <button matChipRemove>
                  <mat-icon class="example-chip-list__delete">cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
        }
        @if (!showMore && group()?.membersIds?.length > 1) {
          <mat-chip-row class="example-chip-list__chip">
            +{{ group()?.membersIds?.length - 1 }}
          </mat-chip-row>
        }
      </div>
      <div class="example-chip-list__input-container">
        <input
          class="example-chip-list__input"
          [ngClass]="{ hidden: !showMore }"
          #memberInput
          placeholder="Add member"
          [formControl]="memberCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        />
      </div>
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (member of filteredMembers(); track member.id) {
        <mat-option [value]="member.id">
          {{ member.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  @if (showMore) {
    <button
      mat-icon-button
      class="chips-cell__show-less"
      matTooltip="Close"
      (click)="onClickShowLess($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
